export function isWindowEmbedded() {
  return window !== null && window.parent !== window;
}
